import React, { useState } from 'react';
import pdf_image from '../../assets/images/pdf.svg';
import ic_excel from '../../assets/images/ic-excel.svg';
import ButtonDropdown from "../buttons/ButtonDropdown";
import {useTranslation} from "react-i18next";
import {IconStackedViews} from "../buttons/IconButtons";
import ModuleExportDataModal from "./ModuleExportDataModal";
/**
 * @email kpozos@ibl.mx
 * @author Karen Yunuen Pozos Arias
 * @title Full Stack Developer
 *
 * @param {string} [id='btn_med_module_export'] - Unique identifier for the dropdown button.
 * @param {string} title - Title displayed in the export modal.
 * @param {string} [classes='btn-icon-accent-450-900'] - CSS classes applied to the button.
 * @param {Function} endPoint - Function or API handler used to execute the export request.
 * @param {Function} renderEndPointBody - Function that builds the request body for the export endpoint.
 * @param {Function} [renderOptions] - Optional function that returns a custom array of dropdown options.
 * It receives an object with helpers ({ setShowModal, setExcel }) and must return an array of option objects.
 * @param {*} exportModuleDataOption - Model or configuration used to define what data will be exported.
 */
const ModuleExportDataBtn = ({
                            id='btn_med_module_export',
                            title,
                            classes='btn-icon-accent-450-900',
                            endPoint,
                            renderEndPointBody,
                            renderOptions,
                            exportModuleDataOption
}) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const [excel, setExcel] = useState(false);

    /**
     * Handles the default export action using the standard endpoint to get Excel or PDF headers.
     * This function is triggered when no custom API call (`callApi`) is provided.
     *
     * @function
     * @param {boolean} isExcel - Flag indicating whether the export should be in Excel format (true) or PDF format (false).
     * @returns {void}
     */
    const handleDownloadOption = (isExcel) => {
        setExcel(isExcel);
        setShowModal(true);
    };

    const options = () => renderOptions ? renderOptions({ setShowModal, setExcel }) : [
        {
            id: 'mim_med_excel',
            option: t('Excel'),
            img: ic_excel,
            action: () => handleDownloadOption(true),
        },
        {
            id: 'mim_med_pdf',
            option: t('PDF'),
            img: pdf_image,
            action: () => handleDownloadOption(false),
        },
    ]

    return (
        <>
            <ButtonDropdown
                id={id}
                classes={classes}
                trans={'module_data'}
                spliName={false}
                icon={IconStackedViews}
                options={options()}
            />

            {showModal && (
                <ModuleExportDataModal
                    show={showModal}
                    title={title}
                    onHide={() => {
                        setShowModal(false);
                    }}
                    excel={excel}
                    endPoint={endPoint}
                    renderEndPointBody={renderEndPointBody}
                    exportModuleDataOption={exportModuleDataOption}
                />
            )}
        </>
    );
};

export default ModuleExportDataBtn;
